import { ApiService } from '~/shared/api'
import { restCreate, sendForm } from '~/shared/utils/decorators'
import { ServiceCanSendForm, ServiceRestCreate } from '~/shared/interfaces'
import { EmployerModel } from '~/model/Employer'
import { isUnknownObject } from '~/shared/utils/guards'
import { RequestService } from '~/services/RequestService'

// eslint-disable-next-line
interface AccountEmployerService extends ServiceRestCreate, ServiceCanSendForm {}

// @ts-ignore
@sendForm
@restCreate

// eslint-disable-next-line no-redeclare
class AccountEmployerService extends ApiService {
  // eslint-disable-next-line no-template-curly-in-string
  protected route: string = 'employers/edit/${slug}'

  constructor(requestService: RequestService, private tstore: any) {
    super(requestService)
  }

  public getAccountEmployer(slug: string): Promise<EmployerModel> {
    return this.requestService
      .request<{ data: unknown }>({
        url: `/api/v1/yavagro/employers/edit/${slug}`
      })
      .then(({ data }) => new EmployerModel(isUnknownObject(data?.data) ? data.data : null))
      .catch(() => {
        this.tstore.notification.removeNotifications()
        return new EmployerModel(null)
      })
  }
}

export default AccountEmployerService
